import React from "react"
import { Link } from "gatsby"

const MobilePages = () => {
    return (
        <div className="mobile-pages-main">
            <div className="text-center">
                <p className="d-inline p-4"><Link to="/info"><span className="text-dark">About game</span></Link></p>
                <p className="d-inline p-4"><Link to="/dev"><span className="text-dark">About author</span></Link></p>
                <p className="d-inline p-4"><a href="https://imgur.com/a/jCC5Ilx" target="_blank"><span className="text-dark">Screenshots</span></a></p>
            </div>
        </div>
    )
}

export default MobilePages
